import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { CountrySVG } from '@common_components/svg/country.svg';

const CountryIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <CountrySVG/>
    </div>
  );
};

export { CountryIcon };
